{
  "Add a new card": "Eine neue Karte hinzufügen",
  "Add a new ACH account": "Ein neues ACH-Konto hinzufügen",
  "Bank": "Bank",
  "Visa": "Visa",
  "Mastercard": "Mastercard",
  "Discover": "Discover",
  "Amerian Express": "American Express",
  "Auto-Pay On": "Automatische Zahlung aktiviert",
  "Auto-Pay Off": "Automatische Zahlung deaktiviert",
  "Payment Method Missing": "Zahlungsmethode fehlt",
  "Home": "Startseite",
  "Reserve": "Reservieren",
  "Menu & Events": "Menü & Veranstaltungen",
  "Billing": "Abrechnung",
  "Sign Out": "Abmelden",
  "Issued Date": "Ausstellungsdatum",
  "Invoice Number": "Rechnungsnummer",
  "Description": "Beschreibung",
  "Invoice Payment Amount": "Rechnungsbetrag",
  "Due Date": "Fälligkeitsdatum",
  "Status": "Status",
  "invoiceEmptyState": "Derzeit haben Sie hier keine offenen Rechnungen.",
  "Payment Due": "Zahlung fällig",
  "Late": "Verspätet",
  "Paid": "Bezahlt",
  "Processing": "Wird bearbeitet",
  "Failed": "Fehlgeschlagen",
  "Voided": "Ungültig",
  "Member Benefits": "Mitgliederleistungen",
  "Meeting Room": "Besprechungsraum",
  "Office": "Büro",
  "Desk": "Schreibtisch",
  "Open Workspace": "Offener Arbeitsplatz",
  "New": "Neu",
  "Your Profile": "Ihr Profil",
  "Company Profile": "Firmenprofil",
  "Member Management": "Mitgliederverwaltung",
  "FAQ": "FAQ",
  "Notification Settings": "Benachrichtigungseinstellungen",
  "Refer a Friend": "Einen Freund empfehlen",
  "beta": "Beta",
  "Something Went Wrong": "Etwas ist schiefgelaufen",
  "Page Not Found": "Seite nicht gefunden",
  "Please refresh the page and try again.": "Bitte aktualisieren Sie die Seite und versuchen Sie es erneut.",
  "Please try our home page.": "Bitte besuchen Sie unsere Startseite.",
  "Refresh": "Aktualisieren"
}
